import { Email, Key } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { buttonSubmitStyle, formStyle } from "../../styles";
import useSnack from "../../hooks/useSnack";
import useApi from "../../hooks/useApi";
import Cookies from "js-cookie";
import { useAuth } from "../../hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";
import SnackAlert from "../../components/SnackAlert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

function Login({ showPassword, changePasswordVisibility }) {
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [mainData, setMainData] = useState({
    username: "",
    password: "",
  });
  const [remember, setRemember] = useState(true);
  const { setLoggedAuth, setUserAuth } = useAuth();
  const navigate = useNavigate();

  const Login = async (e) => {
    e.preventDefault();

    loadApi("login", false, "post", {
      ...mainData,
      remember: !!remember ? "true" : "false",
    })
      .then((response) => {
        LoginSuccess(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      });
  };

  async function LoginSuccess(response) {
    if (!!response?.token && !!response?.userInfo) {
      Cookies.set("CCorbitToken", response?.token, {
        expires: !!response?.exp ? new Date(response?.exp * 1000) : undefined,
        secure: true,
        sameSite: "strict",
      });
      setUserAuth({
        data: response?.userInfo,
        exp: !!response.exp ? response.exp : "noremember",
      });
      setLoggedAuth(true);
      if (response?.userInfo.role === "superadmin") {
        navigate("/dashboard");
      } else {
        navigate("/");
      }
    } else {
      showSnack("Error al conectarse a la API, intente nuevamente.");
    }
  }
  return (
    <>
      <Stack
        component="form"
        sx={{ ...formStyle }}
        spacing={2}
        id="myForm"
        onSubmit={Login}
      >
        <TextField
          name="email"
          id="email-input"
          label="Correo Electrónico"
          variant="standard"
          sx={{
            fontSize: {
              xs: "normal",
              sm: "x-large",
            },
          }}
          onChange={({ target }) =>
            setMainData((adata) => ({ ...adata, username: target.value }))
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Email />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          name="password"
          id="password-input"
          label="Contraseña"
          variant="standard"
          type={showPassword ? "text" : "password"}
          onChange={({ target }) =>
            setMainData((adata) => ({
              ...adata,
              password: target.value,
            }))
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={changePasswordVisibility}>
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Box display="flex" alignItems="center" justifyContent="space-between">
          {/* <FormControlLabel
            label="Recordar"
            control={
              <Checkbox
                name="remember"
                checked={remember}
                onChange={() => {
                  setRemember(remember ? false : true);
                }}
              />
            }
          /> */}
          <Typography
            sx={{
              textDecoration: "underline",
              alignItems: "flex-end",
            }}
            component={Link}
            to="/recuperar-contrasena"
          >
            ¿Olvidaste tu contraseña?
          </Typography>
        </Box>
        <Box textAlign="center">
          <LoadingButton
            type="submit"
            sx={{ ...buttonSubmitStyle }}
            loading={!!loadingApi.includes("post__login")}
          >
            Ingresar
          </LoadingButton>
        </Box>
      </Stack>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default Login;
